import React from 'react';
import {
	Box,
	ComposableTypography,
	Typography,
	useTheme,
} from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { Icons } from '@bcp-nextgen-dx-component-factory/assets-mbcp';
import { rem } from '@helpers';
import { Anything, Color } from '@types';
import { useDoubtsAndExit } from './doubtsAndExit.helper';
import { ROUTES } from '@navigation';
import { Link } from '@components';
import { useNavigationStore } from '@store';

export const DoubtsAndExitPlaceholder: React.FC = () => {
	const { palette } = useTheme();
	const { resources, onHandleLink, onHandleLinkExit } = useDoubtsAndExit();
	const { flow } = useNavigationStore();

	let linkColor: Color | string = Color.Izibizi;

	if (flow === 'integratedSolution') {
		linkColor = palette.global.ui1;
	}

	return (
		<Box styles={{ display: 'flex', flexDirection: 'column', width: '100%', flexGrow: 1 }}>
			<Box styles={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}></Box>
			<Box styles={{ display: 'flex', flexDirection: 'column' }}>
				<Box
					styles={{
						display: 'flex',
						flexDirection: 'row',
						alignItems: 'center',
						paddingLeft: rem(24),
					}}
				>
					<Icons.Call fill={linkColor} />
					<Link onClick={onHandleLink}>
						<ComposableTypography
							text={resources.hasDoubtsAndTalkWithUs}
							baseProps={{
								appearance: 'body-100-02',
								alternativeStyleProperties: { color: linkColor } as Anything,
							}}
							tags={{
								highlight: {
									appearance: 'body-100-04',
									alternativeStyleProperties: { color: linkColor },
								},
							}}
						/>
					</Link>
				</Box>
				{window.location.pathname !== ROUTES.intro && (
					<>
						<Box
							styles={{
								display: 'flex',
								flexDirection: 'column',
								margin: rem(30, 0, 34, 0),
								height: '1px',
								background: palette.global.ui7,
								width: '100%',
							}}
						/>
						<Box styles={{ display: 'flex', flexDirection: 'row', paddingLeft: rem(24) }}>
							<Link onClick={onHandleLinkExit}>
								<Typography appearance="body-100-02" colorsLevel="neutralPrimary">
									{resources.exit}
								</Typography>
							</Link>
						</Box>
					</>
				)}
			</Box>
		</Box>
	);
};
